export enum CampaignPartner {
  ZIP_RECRUITER = 'ZipRecruiter',
  APPCAST = 'AppCast',
  TALROO = 'Talroo',

  // deprecated
  INDEED = 'Indeed',
  LINKEDIN = 'LinkedIn',
  ADZUNA = 'Adzuna',
}

export enum CampaignStatus {
  PENDING = 'Pending',
  ACTIVE = 'Active',
  PAUSED = 'Paused',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
}

export enum CampaignPPC {
  CUSTOM = 'Custom',
  PINTO = 'Pinto',
  FIESTA = 'Fiesta',
  TAURUS = 'Taurus',
  COROLLA = 'Corolla',
  YARIS = 'Yaris',
  RIO = 'Rio',
  CAMRY = 'Camry',
  SOUL = 'Soul',
  FUSION = 'Fusion',
  JETTA = 'Jetta',
  ACCORD = 'Accord',
  MIATA = 'Miata',
  PRIUS = 'Prius',
  NIRO = 'Niro',
  PASSAT = 'Passat',
  COOPER = 'Cooper',
  BOXSTER = 'Boxster',
  TIGUAN = 'Tiguan',
  WRANGLER = 'Wrangler',
  TAHOE = 'Tahoe',
  TELLURIDE = 'Telluride',
  SUPRA = 'Supra',
  MUSTANG = 'Mustang',
  CAMARO = 'Camaro',
  CHARGER = 'Charger',
  CARREERA = 'Carrera',
  CAYMAN = 'Cayman',
  CORVETTE = 'Corvette',
  CAYENNE = 'Cayenne',
  SPYDER = 'Spyder',
  ESPIRIT = 'Espirit',
  NISMO = 'Nismo',
  DELORIAN = 'Delorian',
  VIPER = 'Viper',
  DIABLO = 'Diablo',
  HURACAN = 'Huracan',
  TESTAROSSA = 'Testarossa',
  MURCIELAGO = 'Murcielago',
}

export const CampaignPPCValue: Record<string, number> = {
  PINTO: 0.18,
  FIESTA: 0.2,
  TAURUS: 0.22,
  COROLLA: 0.26,
  YARIS: 0.28,
  RIO: 0.3,
  CAMRY: 0.32,
  SOUL: 0.36,
  FUSION: 0.38,
  JETTA: 0.4,
  ACCORD: 0.42,
  MIATA: 0.46,
  PRIUS: 0.48,
  NIRO: 0.5,
  PASSAT: 0.52,
  COOPER: 0.56,
  BOXSTER: 0.58,
  TIGUAN: 0.6,
  WRANGLER: 0.62,
  TAHOE: 0.66,
  TELLURIDE: 0.68,
  SUPRA: 0.7,
  MUSTANG: 0.72,
  CAMARO: 0.76,
  CHARGER: 0.78,
  CARRERA: 0.8,
  CAYMAN: 0.82,
  CORVETTE: 0.86,
  CAYENNE: 0.88,
  SPYDER: 0.9,
  ESPIRIT: 0.92,
  NISMO: 0.96,
  DELORIAN: 1.0,
  VIPER: 1.5,
  DIABLO: 1.76,
  HURACAN: 2.0,
  TESTAROSSA: 2.5,
  MURCIELAGO: 3.0,
};

export const ConvertStringToCampaignPPC = (ppc: string): CampaignPPC => {
  return CampaignPPC[ppc.toUpperCase() as keyof typeof CampaignPPC];
};

export const ConvertStringToCampaignPartner = (partner: string): CampaignPartner => {
  return CampaignPartner[partner.toUpperCase() as keyof typeof CampaignPartner];
};

export const ConvertStringToCampaignStatus = (status: string): CampaignStatus => {
  return CampaignStatus[status.toUpperCase() as keyof typeof CampaignStatus];
};

export const CampaignPPCString = (ppc: CampaignPPC) => {
  return `$${CampaignPPCValue[ppc.toUpperCase()].toFixed(2)} | ${ppc[0]}${ppc.substring(1).toLowerCase()}`;
};

export const CampaignPartnerOptions = Object.keys(CampaignPartner).map((partner) => ({
  label: partner.charAt(0).toUpperCase() + partner.toLocaleLowerCase().replace(/_/g, ' ').slice(1),
  value: partner,
}));

export const CampaignPPCOptions = Object.keys(CampaignPPCValue).map((ppc) => ({
  label: CampaignPPCString(ppc as CampaignPPC),
  value: CampaignPPC[ppc as keyof typeof CampaignPPC],
}));
